module.exports = __webpack_public_path__ + "static/media/support3.893e293d.png";